import Mapa3 from "./components/Mapa3/Mapa3"

function App() {

  return (
    <>
      <Mapa3 />
    </>
  )
}

export default App
